import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Col, Row } from 'react-bootstrap';
import Button from '../../../ui-core/Button/Button';
import { TEXT_CONSTANT, IMAGE_CONSTANT } from '../../../constants/app';
import { formatCurrency } from '../../../utils/helpers';

import './style.css';
import LazyImage from '../../../ui-core/Image';

const JoinFullBodyImpactPlan = props => {
  const { isLoading, courseDetail } = props;
  const currentPrice = useMemo(() => {
    return courseDetail?.attributes?.amount
      ? +courseDetail?.attributes?.amount / 100
      : 0;
  }, [courseDetail?.attributes?.amount]);
  const backgroundColor = courseDetail?.attributes?.card_color || '#d3dbe9';

  const originalPrice = useMemo(() => {
    return currentPrice + (courseDetail?.attributes?.discount || 0);
  }, [currentPrice, courseDetail?.attributes?.discount]);

  const handleClick = () => {
    if (props.onClick) {
      props.onClick(
        TEXT_CONSTANT.JOIN_THE_COURSE,
        'isSignup',
        TEXT_CONSTANT.GRATEFUL_FOR_MY_BODY_CHALLENGE_H2,
      );
    }
  };

  return (
    <Row
      style={{ backgroundColor }}
      className="full-body-impact row-margin-zero"
    >
      <Col
        className="d-flex justify-content-center align-items-center px-3"
        xs={12}
        md={6}
      >
        <div className="full-body-div text-start d-flex flex-column">
          <h2 className="bold">
            {TEXT_CONSTANT.GRATEFUL_FOR_MY_BODY_CHALLENGE_H2}
          </h2>
          <p>{parse(TEXT_CONSTANT.GRATEFUL_FOR_MY_BODY_DESCRIPTION)}</p>
          {Boolean(courseDetail?.attributes?.amount) && (
            <>
              <p className="mb-1">
                <b className="bold">{TEXT_CONSTANT.GET_STARTED_NOW}</b>
              </p>
              <div className="d-flex">
                {Boolean(courseDetail?.attributes?.discount) && (
                  <p className="foot-health-price-cut">
                    {formatCurrency(
                      originalPrice,
                      courseDetail?.attributes?.currency,
                      2,
                    )}
                  </p>
                )}
                <p className="foot-health-price gratfeul-price">
                  {formatCurrency(
                    currentPrice,
                    courseDetail?.attributes?.currency,
                    2,
                  )}
                </p>
                {!props?.liveNow ? (
                  <div className="foot-health-para-div">
                    <p className="foot-health-para limited-time-text">
                      for a limited time
                    </p>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </>
          )}
          <Button
            onClick={handleClick}
            isDisabled={isLoading}
            isLoading={isLoading}
            text={TEXT_CONSTANT.JOIN_THE_COURSE}
            class="sign-up-button-new d-inline-block mb-3 text-uppercase"
            display
          />
        </div>
      </Col>
      <Col className="p-0 vid-wrapper" xs={12} md={6}>
        <LazyImage
          className="w-100 img-fluid mx-2"
          errorSrc={IMAGE_CONSTANT.GratefulHero}
          placeholderSrc={IMAGE_CONSTANT.GratefulHeroLow}
          src={IMAGE_CONSTANT.GratefulHeroWebp}
        />
      </Col>
    </Row>
  );
};

JoinFullBodyImpactPlan.propTypes = {
  courseDetail: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  liveNow: PropTypes.bool,
};

export default JoinFullBodyImpactPlan;
